import { Loader } from 'components/Loader/Loader';
import { UgPager } from 'components/UgPager/UgPager';
import styles from './GamingHistory.module.css';
import { useTranslation } from 'react-i18next';

export interface MobileGamingHistoryRow {
  id: number;
  timestamp: string;
  gameName: string;
  stake: string;
  gain: string;
}

interface Props {
  rows: MobileGamingHistoryRow[];
  loading: boolean;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  selectedPeriod: string;
  onSelectedPeriodChange: (value: string) => void;
  startDate: string;
  onStartDateChange: (value: string) => void;
  endDate: string;
  onEndDateChange: (value: string) => void;
  providerFilter: string;
  providerOptions: string[];
  onProviderFilterChange: (value: string) => void;
}

export const GamingHistoryMobile = ({
  rows,
  loading,
  page,
  totalPages,
  onPageChange,
  selectedPeriod,
  onSelectedPeriodChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  providerFilter,
  providerOptions,
  onProviderFilterChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.filters}>
        <label>
          Games provider
          <select
            value={providerFilter}
            onChange={(event) => onProviderFilterChange(event.target.value)}
          >
            <option value="all">Select games provider</option>
            {providerOptions.map((provider) => (
              <option key={provider} value={provider}>
                {provider}
              </option>
            ))}
          </select>
        </label>

        <label>
          {t('select_period_label')}
          <select
            value={selectedPeriod}
            onChange={(event) => onSelectedPeriodChange(event.target.value)}
          >
            <option value="0">{t('today_label')}</option>
            <option value="3">{t('last_3_days_label')}</option>
            <option value="7">{t('last_7_days_label')}</option>
            <option value="14">{t('last_14_days_label')}</option>
            <option value="30">{t('last_30_days_label')}</option>
            <option value="60">{t('last_60_days_label')}</option>
            <option value="custom_date">{t('another_period_label')}</option>
          </select>
        </label>

        {selectedPeriod === 'custom_date' && (
          <>
            <label>
              {t('start_date_label')}
              <input
                type="date"
                value={startDate}
                onChange={(e) => onStartDateChange(e.target.value)}
              />
            </label>
            <label>
              {t('end_date_label')}
              <input
                type="date"
                value={endDate}
                onChange={(e) => onEndDateChange(e.target.value)}
              />
            </label>
          </>
        )}
      </div>

      <div className={styles.listHeader}>
        <span>Round</span>
        <span>Game</span>
        <span>Stake/Gain</span>
      </div>

      {loading && <Loader />}
      {!loading &&
        rows.map((row) => (
          <div key={row.id} className={styles.row}>
            <div className={styles.main}>
              <span>{row.id}</span>
              <span>{row.gameName}</span>
              <span>
                {row.stake} / {row.gain}
              </span>
            </div>
            <div className={styles.sub}>
              <span>{row.timestamp}</span>
            </div>
          </div>
        ))}

      <div className={styles.pager}>
        <UgPager
          currentPage={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};
